/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortCallsGet200ResponseRecordsInnerPort
 */
export interface PortCallsGet200ResponseRecordsInnerPort {
    /**
     * 
     * @type {string}
     * @memberof PortCallsGet200ResponseRecordsInnerPort
     */
    locode?: string;
}

/**
 * Check if a given object implements the PortCallsGet200ResponseRecordsInnerPort interface.
 */
export function instanceOfPortCallsGet200ResponseRecordsInnerPort(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortCallsGet200ResponseRecordsInnerPortFromJSON(json: any): PortCallsGet200ResponseRecordsInnerPort {
    return PortCallsGet200ResponseRecordsInnerPortFromJSONTyped(json, false);
}

export function PortCallsGet200ResponseRecordsInnerPortFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortCallsGet200ResponseRecordsInnerPort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locode': !exists(json, 'locode') ? undefined : json['locode'],
    };
}

export function PortCallsGet200ResponseRecordsInnerPortToJSON(value?: PortCallsGet200ResponseRecordsInnerPort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locode': value.locode,
    };
}

